import { makeStyles } from '@vakantiesnl/components/src/styles/themes/themewrapper';
import { type Awards } from '@vakantiesnl/types';

export const useStyles = makeStyles<{ awardType?: Awards.AwardType }>()((theme, { awardType }) => ({
	awardLabelContainer: {
		boxSizing: 'border-box',
		position: 'absolute',
		width: '80px',
		height: '80px',
		left: '0',
		top: '0',
		zIndex: theme.zIndex.lifted,
		padding: theme.spacing.xsmall,
		border: '1px solid',
		borderTopLeftRadius: theme.award.borderRadius,
		boxShadow: theme.award.elevation,
		// emulate triangle
		clipPath: 'polygon(0% 0%, 100% 0%, 0% 100%)',
		// diagonal "border"
		['&:after']: {
			content: '""',
			position: 'absolute',
			top: 'calc(50% - 2px)',
			left: 0,
			width: '100%',
			transform: 'skew(0deg, -45deg)',
			border: '1px solid',
			borderColor: awardType ? theme.award.borderColor[awardType] : 'transparent',
			boxShadow: theme.award.elevation,
		},

		backgroundColor: awardType ? theme.award.backgroundColor[awardType] : 'transparent',
		borderColor: awardType ? theme.award.borderColor[awardType] : 'transparent',
		color: awardType ? theme.award.foregroundColor[awardType] : 'transparent',
	},
}));
